// extracted by mini-css-extract-plugin
export default {"container":"HW11_container__g3X2J","wrapper":"HW11_wrapper__lwgLC","number":"HW11_number__E-yGF"};